<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Contacts') }}</Tab>
                <Tab value="2">{{ __('Rooms') }}</Tab>
                <Tab value="3">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormRadioButton fieldName="category"
                                         label="Category"
                                         size="2"
                                         :data="select?.client_categories"
                                         :isFormDisabled="isFormDisabled"
                                         v-model:field="crud.client_category" />

                        <FormInputText v-if="crud.client_category === 'F'"
                                       fieldName="contractor_name"
                                       label="Contractor name"
                                       validation="required"
                                       size="10"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.contractor_name" />

                        <FormInputText v-if="crud.client_category === 'P'"
                                       fieldName="first_name"
                                       label="First name"
                                       size="5"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.first_name" />

                        <FormInputText v-if="crud.client_category === 'P'"
                                       fieldName="last_name"
                                       label="Last name"
                                       size="5"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.last_name" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="parent_id"
                                    label="Parent contractor"
                                    size="4"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.contractors"
                                    v-model:field="crud.parent_id" />

                        <FormSelect fieldName="opportunity_id"
                                    label="Opportunity"
                                    size="4"
                                    :isFormDisabled="true"
                                    :options="select?.opportunities"
                                    v-model:field="crud.opportunity_id" />

                        <FormSelect fieldName="dcttype_id"
                                    label="Type"
                                    size="4"
                                    :showClear="true"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.dct_contractor_types"
                                    v-model:field="crud.dcttype_id" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="city"
                                       label="City"
                                       size="4"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.city" />

                        <FormInputText fieldName="address"
                                       label="Address"
                                       size="6"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.address" />

                        <FormInputText fieldName="postal_code"
                                       label="Postal code"
                                       size="2"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.postal_code" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="nip"
                                       label="NIP"
                                       size="2"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.nip" />
                        <FormInputText fieldName="bank_account"
                                       label="Bank account number"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.bank_account" />
                        <FormInputText fieldName="phone"
                                       label="Phone"
                                       size="2"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.phone" />

                        <FormInputText fieldName="email"
                                       label="Email"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.email" />
                        <FormInputToggleButton fieldName="is_active"
                                               label="Is active contractor?"
                                               size="2"
                                               :isFormDisabled="isFormDisabled"
                                               v-model:field="crud.is_active" />
                    </div>
                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                    <div class="grid">
                        <FormFileUploader fieldName="files"
                                          label="Attachments"
                                          category="documents"
                                          :allowedExtensions="['pdf', 'docx', 'xlsx', 'txt']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                    </div>
                </TabPanel>

                <TabPanel value="1">
                    <div class="grid">
                        <FormRepeaterTable v-model:record="crud.contacts"
                                           :keys="{ 'last_name': null, 'first_name': null, 'phone': null, 'email': null, 'address': null, 'description': null }"
                                           :isFirstRowEmpty="false"
                                           :isCopyButton="false"
                                           :addButtonName="__('Add contact')"
                                           repeaterStyle="margin-top:5px;width:95%"
                                           name="quotation_products"
                                           :title="[__('Last name'), __('First name'), __('Phone'), __('Email'), __('Address'), __('Description')]">
                            <template #repeat="slotProps">
                                <td style="width:40%;"
                                    :style="slotProps.cellStyle">
                                    <FormInputText fieldName="last_name"
                                                   :inRepeater="true"
                                                   v-model:field="slotProps.record.last_name" />
                                </td>
                                <td style="width:15%"
                                    :style="slotProps.cellStyle">
                                    <FormInputText fieldName="first_name"
                                                   :inRepeater="true"
                                                   v-model:field="slotProps.record.first_name" />
                                </td>
                                <td style="width:15%"
                                    :style="slotProps.cellStyle">
                                    <FormInputText fieldName="phone"
                                                   :inRepeater="true"
                                                   v-model:field="slotProps.record.phone" />
                                </td>
                                <td style="width:15%"
                                    :style="slotProps.cellStyle">
                                    <FormInputText fieldName="email"
                                                   :inRepeater="true"
                                                   v-model:field="slotProps.record.email" />
                                </td>
                                <td style="width:15%"
                                    :style="slotProps.cellStyle">
                                    <FormInputText fieldName="address"
                                                   :inRepeater="true"
                                                   v-model:field="slotProps.record.address" />
                                </td>
                                <td style="width:15%"
                                    :style="slotProps.cellStyle">
                                    <FormTextarea fieldName="description"
                                                  :inRepeater="true"
                                                  :rows="2"
                                                  v-model:field="slotProps.record.description" />
                                </td>
                            </template>
                        </FormRepeaterTable>
                    </div>
                </TabPanel>

                <TabPanel value="2">
                    <div :name="'contractorrooms'"></div>
                    <FormRepeaterTable v-model:record="crud.contractorrooms"
                                       :keys="{ 'room_name': null, 'floor': null, 'description': null, 'documents': null }"
                                       :isFirstRowEmpty="false"
                                       :isCopyButton="false"
                                       :addButtonName="__('Add room')"
                                       repeaterStyle="margin-top:13px;width:99%"
                                       name="contractorrooms"
                                       :title="[__('Room name'), __('Floor'), __('Description'), __('Documents')]">

                        <template #repeat="slotProps">
                            <td style="width:30%;"
                                :style="slotProps.cellStyle">
                                <FormInputText fieldName="room_name"
                                               :inRepeater="true"
                                               v-model:field="slotProps.record.room_name" />
                            </td>
                            <td style="width:5%"
                                :style="slotProps.cellStyle">
                                <FormInputNumber fieldName="floor"
                                                 :inRepeater="true"
                                                 v-model:field="slotProps.record.floor" />
                            </td>
                            <td style="width:30%"
                                :style="slotProps.cellStyle">
                                <FormTextarea fieldName="description"
                                              :inRepeater="true"
                                              :rows="3"
                                              v-model:field="slotProps.record.description" />
                            </td>
                            <td style="width:35%;border-width:1px;">
                                <FormFileUploader fieldName="files"
                                                  category="documents"
                                                  imgPosition="left"
                                                  :inRepeater="true"
                                                  :isShortNames="true"
                                                  :showSizeInfo="false"
                                                  :allowedExtensions="['pdf', 'docx', 'xlsx', 'txt', 'jpg', 'jpeg', 'png', 'gif']"
                                                  :style="{ marginTop: '28px', minWidth: '100px', display: 'flex', flexDirection: 'column-reverse' }"
                                                  v-model:field="slotProps.record.files" />
                            </td>
                        </template>
                    </FormRepeaterTable>
                </TabPanel>



                <TabPanel v-if="crud.log"
                          value="3"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="formProps.buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>
        <AlertAdd :formProps="{ source_table: 'contractors', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormRadioButton from '@crud/FormRadioButton.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormButtons from '@crud/FormButtons.vue'
import FormRepeaterTable from '@crud/FormRepeaterTable.vue'
import FormFileUploader from '@crud/FormFileUploader.vue'
import FormTextarea from '@crud/FormTextarea.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import AlertAdd from '@app/Data/Alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import FormInputToggleButton from '@crud/FormInputToggleButton.vue'
import { validation, initFormObj } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})
const buttonsVisibility = ref({})

const options = ["contractors", "client_categories", "opportunities", "dct_contractor_types"];
const select = ref(null);
const isAddAlertDialogOpen = ref(false);

// -----------------------------------------------------

onMounted(async () => {
    await initFormObj({ props, crud, isLoading, options, select, initialData: { is_active: true } })
})

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
